module.exports = __webpack_public_path__ + "static/media/consensys.955b10ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/consensys.png
// module id = 1852
// module chunks = 147